"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CameraListItem = void 0;
var _core = require("@material-ui/core");
var _pittaDesignSystem = require("@thingsw/pitta-design-system");
var _pittaModules = require("@thingsw/pitta-modules");
var _clsx2 = _interopRequireDefault(require("clsx"));
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    camListImg: {
      width: 22,
      height: 22,
      borderRadius: '50%',
      margin: 3
    },
    camListImgLive: {
      // 아이콘 사이즈가 다른 부분 동일하게 적용 (Leehj)
      width: 22,
      height: 22,
      border: "2px solid ".concat(_pittaModules.LightColors.secondary['11'])
    },
    camListImgAppLive: {
      width: 18,
      height: 18,
      border: "2px solid ".concat(_pittaModules.LightColors.secondary['11'])
    },
    titleStyle: {
      marginLeft: -2
    }
  };
});
var CameraListItem = function CameraListItem(_ref) {
  var loc = _ref.loc,
    index = _ref.index,
    onClick = _ref.onClick,
    last = _ref.last,
    app = _ref.app,
    t = _ref.t,
    colors = _ref.colors;
  if (loc.share_dev_name === 'off' && loc.share_video === 'off') {
    return null;
  }
  var classes = useStyles();
  var theme = (0, _core.useTheme)();
  var mobile = (0, _core.useMediaQuery)(theme.breakpoints.down(_pittaModules.Webviewer.mobile));
  var logoMarkup = (0, _react.useMemo)(function () {
    if (loc.isPublic) {
      if (loc.share_dev_name !== 'on') {
        if (loc.share_video !== 'on') {
          // https://www.figma.com/file/HhRl2r74ne0WOMypyBp50U/Mapbox?node-id=229%3A68055&t=CezpuXi82ZgineGX-4
          return /*#__PURE__*/_react["default"].createElement("svg", {
            width: "28",
            height: "28",
            viewBox: "0 0 28 28",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }, /*#__PURE__*/_react["default"].createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13.9256 3.07227C19.9572 3.07227 24.8511 7.98334 24.8511 14.0361C24.8511 20.0889 19.9572 24.9999 13.9256 24.9999C7.89392 24.9818 3 20.0889 3 14.0361C3 7.96522 7.89392 3.07227 13.9256 3.07227Z",
            fill: "#030303"
          }), /*#__PURE__*/_react["default"].createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13.9257 23.6047C8.65249 23.6047 4.39062 19.3097 4.39062 14.0362C4.39062 8.74458 8.65249 4.46777 13.9257 4.46777C19.1988 4.46777 23.4607 8.74458 23.4607 14.0362C23.4607 19.3097 19.1808 23.6047 13.9257 23.6047Z",
            fill: "white"
          }), /*#__PURE__*/_react["default"].createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13.9255 6.37012C9.7178 6.37012 6.30469 9.79518 6.30469 14.0176C6.30469 18.2401 9.7178 21.6832 13.9255 21.6832C18.1332 21.6832 21.5644 18.2582 21.5644 14.0176C21.5463 9.79518 18.1332 6.37012 13.9255 6.37012Z",
            fill: "#030303"
          }), /*#__PURE__*/_react["default"].createElement("path", {
            d: "M12.7881 14.5981C12.6437 6.91436 9.68202 4.57662 6.32309 3C6.32309 3 5.85356 9.81389 12.7881 14.5981Z",
            fill: "#678D2A"
          }), /*#__PURE__*/_react["default"].createElement("path", {
            d: "M12.6436 14.2902C12.5352 7.34949 9.53746 4.68555 6.44941 3.25391C6.44941 3.25391 6.32299 9.85033 12.6436 14.2902Z",
            fill: "url(#paint0_linear_229_68055)"
          }), /*#__PURE__*/_react["default"].createElement("path", {
            d: "M12.5353 15.069C9.08609 10.6291 6.3231 10.5204 3.68652 11.0822C3.68652 11.0822 6.34116 15.2865 12.5353 15.069Z",
            fill: "#3576AE"
          }), /*#__PURE__*/_react["default"].createElement("path", {
            d: "M12.1562 14.9061C8.97783 10.8287 6.16067 10.7018 3.90332 11.173C3.90332 11.173 6.77466 15.0511 12.1562 14.9061Z",
            fill: "url(#paint1_linear_229_68055)"
          }), /*#__PURE__*/_react["default"].createElement("path", {
            d: "M14.6841 18.6397L11.2529 18.8753C11.2529 18.8753 11.9933 15.5771 13.3116 14.7253V14.671C13.2755 13.185 13.1491 11.9164 12.8782 10.8291L15.0453 13.8374C15.0453 13.8374 17.1581 12.3151 19.56 13.8374C19.56 13.8374 21.7812 13.8917 24.5261 14.5622C24.5261 14.5622 21.2936 14.381 19.3613 15.2871C19.3613 15.269 18.8557 18.0417 14.6841 18.6397Z",
            fill: "#E2AF00"
          }), /*#__PURE__*/_react["default"].createElement("path", {
            d: "M14.6476 18.4945L11.4512 18.7119C11.4512 18.7119 12.1735 15.4681 13.4738 14.7794L13.4196 14.707C13.4015 13.4384 13.3293 12.4598 13.1126 11.3906L14.9546 14.0183C14.9546 14.0183 17.2842 12.4779 19.4331 13.9821C19.4331 13.9821 21.0404 13.8915 23.37 14.4533C23.37 14.4533 21.2932 14.2358 19.2345 15.1419C19.2526 15.1419 18.8011 17.9508 14.6476 18.4945Z",
            fill: "url(#paint2_linear_229_68055)"
          }), /*#__PURE__*/_react["default"].createElement("path", {
            d: "M10.6029 17.624C10.6029 17.624 11.867 21.8827 13.0047 22.3176C12.174 22.6076 10.7112 23.3143 9.73604 24.3654C9.68186 24.456 9.23039 20.1974 10.6029 17.624Z",
            fill: "#A60C1C"
          }), /*#__PURE__*/_react["default"].createElement("path", {
            d: "M10.5486 17.8965C10.5486 17.8965 11.7405 21.9196 12.7156 22.282C12.0113 22.5176 10.6208 23.1881 9.79012 24.0942C9.754 24.1848 9.46506 20.4336 10.5486 17.8965Z",
            fill: "url(#paint3_linear_229_68055)"
          }), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("linearGradient", {
            id: "paint0_linear_229_68055",
            x1: "7.69672",
            y1: "3.33335",
            x2: "11.9562",
            y2: "14.4943",
            gradientUnits: "userSpaceOnUse"
          }, /*#__PURE__*/_react["default"].createElement("stop", {
            stopColor: "#8BC126"
          }), /*#__PURE__*/_react["default"].createElement("stop", {
            offset: "1",
            stopColor: "#8CC125"
          })), /*#__PURE__*/_react["default"].createElement("linearGradient", {
            id: "paint1_linear_229_68055",
            x1: "4.3887",
            y1: "11.3678",
            x2: "12.0656",
            y2: "14.4076",
            gradientUnits: "userSpaceOnUse"
          }, /*#__PURE__*/_react["default"].createElement("stop", {
            stopColor: "#569DD2"
          }), /*#__PURE__*/_react["default"].createElement("stop", {
            offset: "1",
            stopColor: "#5FA8E0"
          })), /*#__PURE__*/_react["default"].createElement("linearGradient", {
            id: "paint2_linear_229_68055",
            x1: "16.3931",
            y1: "11.1529",
            x2: "17.6185",
            y2: "17.5744",
            gradientUnits: "userSpaceOnUse"
          }, /*#__PURE__*/_react["default"].createElement("stop", {
            stopColor: "#FADDA2"
          }), /*#__PURE__*/_react["default"].createElement("stop", {
            offset: "0.0756794",
            stopColor: "#F9D793"
          }), /*#__PURE__*/_react["default"].createElement("stop", {
            offset: "0.4002",
            stopColor: "#F5C35B"
          }), /*#__PURE__*/_react["default"].createElement("stop", {
            offset: "0.6735",
            stopColor: "#F2B42E"
          }), /*#__PURE__*/_react["default"].createElement("stop", {
            offset: "0.8816",
            stopColor: "#F0AC0C"
          }), /*#__PURE__*/_react["default"].createElement("stop", {
            offset: "1",
            stopColor: "#F0A900"
          })), /*#__PURE__*/_react["default"].createElement("linearGradient", {
            id: "paint3_linear_229_68055",
            x1: "11.8321",
            y1: "18.0885",
            x2: "10.8521",
            y2: "24.1087",
            gradientUnits: "userSpaceOnUse"
          }, /*#__PURE__*/_react["default"].createElement("stop", {
            stopColor: "#D76049"
          }), /*#__PURE__*/_react["default"].createElement("stop", {
            offset: "0.3211",
            stopColor: "#D34635"
          }), /*#__PURE__*/_react["default"].createElement("stop", {
            offset: "0.7666",
            stopColor: "#CE2223"
          }), /*#__PURE__*/_react["default"].createElement("stop", {
            offset: "1",
            stopColor: "#CC0B1E"
          }))));
        } else {
          // https://www.figma.com/file/HhRl2r74ne0WOMypyBp50U/Mapbox?node-id=229%3A67967&t=CezpuXi82ZgineGX-4
          return /*#__PURE__*/_react["default"].createElement("svg", {
            width: "28",
            height: "28",
            viewBox: "0 0 28 28",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }, /*#__PURE__*/_react["default"].createElement("path", {
            d: "M24.3 14C24.3 19.6885 19.6885 24.3 14 24.3C8.31147 24.3 3.7 19.6885 3.7 14C3.7 8.31147 8.31147 3.7 14 3.7C19.6885 3.7 24.3 8.31147 24.3 14Z",
            fill: "white",
            stroke: "#D81A26",
            strokeWidth: "1.4"
          }), /*#__PURE__*/_react["default"].createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13.9507 6.71484C17.9718 6.71484 21.2344 9.98889 21.2344 14.0241C21.2344 18.0592 17.9718 21.3333 13.9507 21.3333C9.92961 21.3212 6.66699 18.0592 6.66699 14.0241C6.66699 9.97681 9.92961 6.71484 13.9507 6.71484Z",
            fill: "#030303"
          }), /*#__PURE__*/_react["default"].createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13.9504 20.4034C10.435 20.4034 7.59375 17.5401 7.59375 14.0245C7.59375 10.4967 10.435 7.64551 13.9504 7.64551C17.4659 7.64551 20.3071 10.4967 20.3071 14.0245C20.3071 17.5401 17.4538 20.4034 13.9504 20.4034Z",
            fill: "white"
          }), /*#__PURE__*/_react["default"].createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13.9507 8.91406C11.1455 8.91406 8.87012 11.1974 8.87012 14.0124C8.87012 16.8274 11.1455 19.1228 13.9507 19.1228C16.7558 19.1228 19.0432 16.8394 19.0432 14.0124C19.0312 11.1974 16.7558 8.91406 13.9507 8.91406Z",
            fill: "#030303"
          }), /*#__PURE__*/_react["default"].createElement("path", {
            d: "M13.1924 14.3991C13.0961 9.27657 11.1217 7.71807 8.88238 6.66699C8.88238 6.66699 8.56936 11.2096 13.1924 14.3991Z",
            fill: "#678D2A"
          }), /*#__PURE__*/_react["default"].createElement("path", {
            d: "M13.0964 14.1935C13.0241 9.56633 11.0256 7.79037 8.96692 6.83594C8.96692 6.83594 8.88265 11.2336 13.0964 14.1935Z",
            fill: "url(#paint0_linear_229_67967)"
          }), /*#__PURE__*/_react["default"].createElement("path", {
            d: "M13.0242 14.7133C10.7247 11.7534 8.88272 11.6809 7.125 12.0554C7.125 12.0554 8.89476 14.8583 13.0242 14.7133Z",
            fill: "#3576AE"
          }), /*#__PURE__*/_react["default"].createElement("path", {
            d: "M12.7714 14.6044C10.6525 11.8861 8.77443 11.8015 7.26953 12.1157C7.26953 12.1157 9.18376 14.7011 12.7714 14.6044Z",
            fill: "url(#paint1_linear_229_67967)"
          }), /*#__PURE__*/_react["default"].createElement("path", {
            d: "M14.4564 17.0938L12.1689 17.2508C12.1689 17.2508 12.6626 15.052 13.5414 14.4842V14.448C13.5173 13.4573 13.4331 12.6116 13.2525 11.8867L14.6972 13.8922C14.6972 13.8922 16.1058 12.8774 17.707 13.8922C17.707 13.8922 19.1878 13.9285 21.0177 14.3755C21.0177 14.3755 18.8627 14.2547 17.5745 14.8587C17.5745 14.8467 17.2374 16.6951 14.4564 17.0938Z",
            fill: "#E2AF00"
          }), /*#__PURE__*/_react["default"].createElement("path", {
            d: "M14.4317 16.9966L12.3008 17.1416C12.3008 17.1416 12.7823 14.979 13.6492 14.52L13.6131 14.4716C13.601 13.6259 13.5529 12.9735 13.4084 12.2607L14.6364 14.0125C14.6364 14.0125 16.1894 12.9856 17.6221 13.9884C17.6221 13.9884 18.6936 13.928 20.2466 14.3025C20.2466 14.3025 18.8621 14.1575 17.4897 14.7616C17.5017 14.7616 17.2007 16.6342 14.4317 16.9966Z",
            fill: "url(#paint2_linear_229_67967)"
          }), /*#__PURE__*/_react["default"].createElement("path", {
            d: "M11.7359 16.417C11.7359 16.417 12.5786 19.2561 13.3371 19.5461C12.7833 19.7394 11.8081 20.2105 11.158 20.9113C11.1219 20.9717 10.8209 18.1325 11.7359 16.417Z",
            fill: "#A60C1C"
          }), /*#__PURE__*/_react["default"].createElement("path", {
            d: "M11.6991 16.5977C11.6991 16.5977 12.4936 19.2797 13.1438 19.5213C12.6742 19.6784 11.7472 20.1254 11.1934 20.7295C11.1693 20.7899 10.9767 18.289 11.6991 16.5977Z",
            fill: "url(#paint3_linear_229_67967)"
          }), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("linearGradient", {
            id: "paint0_linear_229_67967",
            x1: "9.79846",
            y1: "6.8889",
            x2: "12.6381",
            y2: "14.3295",
            gradientUnits: "userSpaceOnUse"
          }, /*#__PURE__*/_react["default"].createElement("stop", {
            stopColor: "#8BC126"
          }), /*#__PURE__*/_react["default"].createElement("stop", {
            offset: "1",
            stopColor: "#8CC125"
          })), /*#__PURE__*/_react["default"].createElement("linearGradient", {
            id: "paint1_linear_229_67967",
            x1: "7.59312",
            y1: "12.2455",
            x2: "12.7111",
            y2: "14.272",
            gradientUnits: "userSpaceOnUse"
          }, /*#__PURE__*/_react["default"].createElement("stop", {
            stopColor: "#569DD2"
          }), /*#__PURE__*/_react["default"].createElement("stop", {
            offset: "1",
            stopColor: "#5FA8E0"
          })), /*#__PURE__*/_react["default"].createElement("linearGradient", {
            id: "paint2_linear_229_67967",
            x1: "15.5954",
            y1: "12.1023",
            x2: "16.4123",
            y2: "16.3832",
            gradientUnits: "userSpaceOnUse"
          }, /*#__PURE__*/_react["default"].createElement("stop", {
            stopColor: "#FADDA2"
          }), /*#__PURE__*/_react["default"].createElement("stop", {
            offset: "0.0756794",
            stopColor: "#F9D793"
          }), /*#__PURE__*/_react["default"].createElement("stop", {
            offset: "0.4002",
            stopColor: "#F5C35B"
          }), /*#__PURE__*/_react["default"].createElement("stop", {
            offset: "0.6735",
            stopColor: "#F2B42E"
          }), /*#__PURE__*/_react["default"].createElement("stop", {
            offset: "0.8816",
            stopColor: "#F0AC0C"
          }), /*#__PURE__*/_react["default"].createElement("stop", {
            offset: "1",
            stopColor: "#F0A900"
          })), /*#__PURE__*/_react["default"].createElement("linearGradient", {
            id: "paint3_linear_229_67967",
            x1: "12.5548",
            y1: "16.7257",
            x2: "11.9014",
            y2: "20.7391",
            gradientUnits: "userSpaceOnUse"
          }, /*#__PURE__*/_react["default"].createElement("stop", {
            stopColor: "#D76049"
          }), /*#__PURE__*/_react["default"].createElement("stop", {
            offset: "0.3211",
            stopColor: "#D34635"
          }), /*#__PURE__*/_react["default"].createElement("stop", {
            offset: "0.7666",
            stopColor: "#CE2223"
          }), /*#__PURE__*/_react["default"].createElement("stop", {
            offset: "1",
            stopColor: "#CC0B1E"
          }))));
        }
      } else {
        var basicSvg = "\n    <svg style=\"margin:3px\" width=\"22\" height=\"22\" viewBox=\"0 0 44 44\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n    <g clip-path=\"url(#clip0_11889_121452)\">\n    \n    <g clip-path=\"url(#clip1_11889_121452)\">\n    <rect width=\"44\" height=\"44\" fill=\"".concat(loc.share_video !== 'on' ? '#E9E9EA' : '#D81A26', "\"/>\n    <circle cx=\"22\" cy=\"22\" r=\"19\" fill=\"#E9E9EA\"/>\n    <g opacity=\"0.85\">\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M21.9289 11.0664C27.9635 11.0664 32.8598 15.9799 32.8598 22.0356C32.8598 28.0913 27.9635 33.0047 21.9289 33.0047C15.8944 32.9866 10.998 28.0913 10.998 22.0356C10.998 15.9617 15.8944 11.0664 21.9289 11.0664Z\" fill=\"#030303\"/>\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M21.9303 31.6091C16.6546 31.6091 12.3906 27.3121 12.3906 22.036C12.3906 16.7418 16.6546 12.4629 21.9303 12.4629C27.206 12.4629 31.4699 16.7418 31.4699 22.036C31.4699 27.3121 27.1879 31.6091 21.9303 31.6091Z\" fill=\"white\"/>\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M21.9272 14.3682C17.7175 14.3682 14.3027 17.7949 14.3027 22.0194C14.3027 26.2439 17.7175 29.6887 21.9272 29.6887C26.137 29.6887 29.5698 26.262 29.5698 22.0194C29.5517 17.7949 26.137 14.3682 21.9272 14.3682Z\" fill=\"#030303\"/>\n    <path d=\"M20.7922 22.5989C20.6477 14.9114 17.6846 12.5725 14.3241 10.9951C14.3241 10.9951 13.8543 17.8123 20.7922 22.5989Z\" fill=\"#678D2A\"/>\n    <path d=\"M20.6475 22.2907C20.5391 15.3466 17.5399 12.6814 14.4504 11.249C14.4504 11.249 14.3239 17.8487 20.6475 22.2907Z\" fill=\"url(#paint0_linear_11889_121452)\"/>\n    <path d=\"M20.5386 23.0711C17.0877 18.629 14.3234 18.5202 11.6855 19.0823C11.6855 19.0823 14.3415 23.2886 20.5386 23.0711Z\" fill=\"#3576AE\"/>\n    <path d=\"M20.1573 22.908C16.9774 18.8286 14.1588 18.7017 11.9004 19.1731C11.9004 19.1731 14.7731 23.0531 20.1573 22.908Z\" fill=\"url(#paint1_linear_11889_121452)\"/>\n    <path d=\"M22.6877 26.6406L19.2549 26.8763C19.2549 26.8763 19.9957 23.5765 21.3146 22.7243V22.6699C21.2784 21.1832 21.152 19.914 20.881 18.8262L23.0491 21.8359C23.0491 21.8359 25.163 20.3129 27.566 21.8359C27.566 21.8359 29.7883 21.8903 32.5345 22.5611C32.5345 22.5611 29.3004 22.3798 27.3672 23.2864C27.3672 23.2682 26.8613 26.0423 22.6877 26.6406Z\" fill=\"#E2AF00\"/>\n    <path d=\"M22.654 26.496L19.4561 26.7135C19.4561 26.7135 20.1788 23.4681 21.4796 22.7791L21.4254 22.7066C21.4073 21.4375 21.3351 20.4584 21.1183 19.3887L22.9612 22.0176C22.9612 22.0176 25.2919 20.4765 27.4419 21.9814C27.4419 21.9814 29.0499 21.8907 31.3806 22.4528C31.3806 22.4528 29.3029 22.2352 27.2432 23.1418C27.2612 23.1418 26.8095 25.952 22.654 26.496Z\" fill=\"url(#paint2_linear_11889_121452)\"/>\n    <path d=\"M18.6033 25.626C18.6033 25.626 19.8681 29.8867 21.0063 30.3219C20.1752 30.612 18.7117 31.3191 17.7361 32.3707C17.6819 32.4613 17.2302 28.2006 18.6033 25.626Z\" fill=\"#A60C1C\"/>\n    <path d=\"M18.55 25.8984C18.55 25.8984 19.7424 29.9235 20.7181 30.2861C20.0134 30.5218 18.6222 31.1926 17.7911 32.0992C17.755 32.1898 17.4659 28.4368 18.55 25.8984Z\" fill=\"url(#paint3_linear_11889_121452)\"/>\n    </g>\n    </g>\n    </g>\n    <defs>\n    <linearGradient id=\"paint0_linear_11889_121452\" x1=\"15.6983\" y1=\"11.3285\" x2=\"19.9599\" y2=\"22.4949\" gradientUnits=\"userSpaceOnUse\">\n    <stop stop-color=\"#8BC126\"/>\n    <stop offset=\"1\" stop-color=\"#8CC125\"/>\n    </linearGradient>\n    <linearGradient id=\"paint1_linear_11889_121452\" x1=\"12.386\" y1=\"19.3679\" x2=\"20.0667\" y2=\"22.4092\" gradientUnits=\"userSpaceOnUse\">\n    <stop stop-color=\"#569DD2\"/>\n    <stop offset=\"1\" stop-color=\"#5FA8E0\"/>\n    </linearGradient>\n    <linearGradient id=\"paint2_linear_11889_121452\" x1=\"24.4004\" y1=\"19.1509\" x2=\"25.6264\" y2=\"25.5754\" gradientUnits=\"userSpaceOnUse\">\n    <stop stop-color=\"#FADDA2\"/>\n    <stop offset=\"0.0756794\" stop-color=\"#F9D793\"/>\n    <stop offset=\"0.4002\" stop-color=\"#F5C35B\"/>\n    <stop offset=\"0.6735\" stop-color=\"#F2B42E\"/>\n    <stop offset=\"0.8816\" stop-color=\"#F0AC0C\"/>\n    <stop offset=\"1\" stop-color=\"#F0A900\"/>\n    </linearGradient>\n    <linearGradient id=\"paint3_linear_11889_121452\" x1=\"19.8341\" y1=\"26.0906\" x2=\"18.8536\" y2=\"32.1137\" gradientUnits=\"userSpaceOnUse\">\n    <stop stop-color=\"#D76049\"/>\n    <stop offset=\"0.3211\" stop-color=\"#D34635\"/>\n    <stop offset=\"0.7666\" stop-color=\"#CE2223\"/>\n    <stop offset=\"1\" stop-color=\"#CC0B1E\"/>\n    </linearGradient>\n    <clipPath id=\"clip0_11889_121452\">\n    <rect width=\"44\" height=\"44\" rx=\"22\" fill=\"white\"/>\n    </clipPath>\n    <clipPath id=\"clip1_11889_121452\">\n    <rect width=\"44\" height=\"44\" fill=\"white\"/>\n    </clipPath>\n    </defs>\n    </svg>\n  ");
        if (loc.share_video !== 'on') {
          var _loc$profile_img_v;
          // eslint-disable-next-line jsx-a11y/alt-text
          return (_loc$profile_img_v = loc.profile_img_v2) !== null && _loc$profile_img_v !== void 0 && _loc$profile_img_v.includes('json') ? /*#__PURE__*/_react["default"].createElement("div", {
            dangerouslySetInnerHTML: {
              __html: basicSvg
            }
          }) : /*#__PURE__*/_react["default"].createElement("img", {
            src: loc.profile_img_v2,
            className: classes.camListImg
          });
        } else {
          var _loc$profile_img_v2;
          return (_loc$profile_img_v2 = loc.profile_img_v2) !== null && _loc$profile_img_v2 !== void 0 && _loc$profile_img_v2.includes('json') ? /*#__PURE__*/_react["default"].createElement("div", {
            dangerouslySetInnerHTML: {
              __html: basicSvg
            }
          }) :
          /*#__PURE__*/
          // eslint-disable-next-line jsx-a11y/alt-text
          _react["default"].createElement("img", {
            src: loc.profile_img_v2,
            className: (0, _clsx2["default"])(classes.camListImg, classes.camListImgLive, _defineProperty({}, classes.camListImgAppLive, app || mobile))
          });
        }
      }
    } else {
      // https://www.figma.com/file/HhRl2r74ne0WOMypyBp50U/Mapbox?node-id=239%3A68177&t=CezpuXi82ZgineGX-4
      if (loc.active === 'off') {
        return (
          /*#__PURE__*/
          // 해당 아이콘만 크기가 맞지않아 svg크기변경 후 div로 감싸주어 스타일 적용 (Leehj)
          _react["default"].createElement("div", {
            style: {
              display: 'flex',
              marginLeft: -2,
              marginRight: -2
            }
          }, /*#__PURE__*/_react["default"].createElement("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 28 28",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }, /*#__PURE__*/_react["default"].createElement("circle", {
            cx: "13.9994",
            cy: "13.9994",
            r: "10.3394",
            fill: "white",
            stroke: "white",
            strokeWidth: "1.31993"
          }), /*#__PURE__*/_react["default"].createElement("mask", {
            id: "mask0_239_68177",
            style: {
              maskType: 'alpha'
            },
            maskUnits: "userSpaceOnUse",
            x: "4",
            y: "4",
            width: "20",
            height: "20"
          }, /*#__PURE__*/_react["default"].createElement("circle", {
            cx: "14.0003",
            cy: "13.9984",
            r: "8.76808",
            fill: "#B1BBDE",
            stroke: "#BEBEC1",
            strokeWidth: "1.31993"
          })), /*#__PURE__*/_react["default"].createElement("g", {
            mask: "url(#mask0_239_68177)"
          }, /*#__PURE__*/_react["default"].createElement("circle", {
            cx: "14.0023",
            cy: "13.9984",
            r: "9.42804",
            fill: "#68686E"
          }), /*#__PURE__*/_react["default"].createElement("path", {
            d: "M10.0732 19.0478C10.0732 18.0272 10.4871 17.0484 11.2238 16.3267C11.9605 15.605 12.9597 15.1996 14.0016 15.1996C15.0435 15.1996 16.0426 15.605 16.7794 16.3267C17.5161 17.0484 17.9299 18.0272 17.9299 19.0478H10.0732ZM14.0016 14.7186C12.3738 14.7186 11.0553 13.427 11.0553 11.8324C11.0553 10.2378 12.3738 8.94629 14.0016 8.94629C15.6294 8.94629 16.9479 10.2378 16.9479 11.8324C16.9479 13.427 15.6294 14.7186 14.0016 14.7186Z",
            fill: "white"
          }))))
        );
      } else {
        if (loc.mode === '1') {
          return /*#__PURE__*/_react["default"].createElement("svg", {
            width: "28",
            height: "28",
            viewBox: "0 0 28 28",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }, /*#__PURE__*/_react["default"].createElement("circle", {
            cx: "13.4348",
            cy: "14.5647",
            r: "9.80871",
            fill: "white",
            stroke: "white",
            strokeWidth: "1.25218"
          }), /*#__PURE__*/_react["default"].createElement("mask", {
            id: "mask0_239_68181",
            style: {
              maskType: 'alpha'
            },
            maskUnits: "userSpaceOnUse",
            x: "4",
            y: "5",
            width: "19",
            height: "19"
          }, /*#__PURE__*/_react["default"].createElement("circle", {
            cx: "13.4343",
            cy: "14.5652",
            r: "8.31802",
            fill: "#B1BBDE",
            stroke: "#BEBEC1",
            strokeWidth: "1.25218"
          })), /*#__PURE__*/_react["default"].createElement("g", {
            mask: "url(#mask0_239_68181)"
          }, /*#__PURE__*/_react["default"].createElement("circle", {
            cx: "13.4334",
            cy: "14.5652",
            r: "8.94411",
            fill: "#0095E0"
          }), /*#__PURE__*/_react["default"].createElement("path", {
            d: "M10.4521 10.8379H14.0642C14.8853 10.8379 15.6728 11.1408 16.2534 11.6799C16.834 12.2191 17.1602 12.9503 17.1602 13.7128C17.1602 14.4753 16.834 15.2065 16.2534 15.7456C15.6728 16.2848 14.8853 16.5877 14.0642 16.5877H12.5162V19.4626H10.4521V10.8379ZM12.5162 12.7545V14.6711H14.0642C14.3379 14.6711 14.6004 14.5701 14.7939 14.3904C14.9875 14.2107 15.0962 13.9669 15.0962 13.7128C15.0962 13.4586 14.9875 13.2149 14.7939 13.0352C14.6004 12.8554 14.3379 12.7545 14.0642 12.7545H12.5162Z",
            fill: "white"
          })), /*#__PURE__*/_react["default"].createElement("rect", {
            x: "13.9563",
            y: "2.0432",
            width: "11.4777",
            height: "7.304",
            rx: "2.60857",
            fill: "#3C3C3C",
            stroke: "white",
            strokeWidth: "1.04343"
          }), /*#__PURE__*/_react["default"].createElement("circle", {
            cx: "17.6081",
            cy: "5.69503",
            r: "1.04343",
            stroke: "white",
            strokeWidth: "1.04343"
          }), /*#__PURE__*/_react["default"].createElement("circle", {
            cx: "24.9121",
            cy: "3.08686",
            r: "1.56514",
            fill: "#DF434D",
            stroke: "white",
            strokeWidth: "1.04343"
          }));
        } else {
          // https://www.figma.com/file/HhRl2r74ne0WOMypyBp50U/Mapbox?node-id=239%3A68182&t=CezpuXi82ZgineGX-4
          return /*#__PURE__*/_react["default"].createElement("svg", {
            width: "28",
            height: "28",
            viewBox: "0 0 28 28",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }, /*#__PURE__*/_react["default"].createElement("circle", {
            cx: "13.4336",
            cy: "14.5644",
            r: "9.80849",
            fill: "white",
            stroke: "white",
            strokeWidth: "1.25215"
          }), /*#__PURE__*/_react["default"].createElement("mask", {
            id: "mask0_239_68182",
            style: {
              maskType: 'alpha'
            },
            maskUnits: "userSpaceOnUse",
            x: "4",
            y: "5",
            width: "19",
            height: "19"
          }, /*#__PURE__*/_react["default"].createElement("circle", {
            cx: "13.4351",
            cy: "14.564",
            r: "8.31783",
            fill: "#B1BBDE",
            stroke: "#BEBEC1",
            strokeWidth: "1.25215"
          })), /*#__PURE__*/_react["default"].createElement("g", {
            mask: "url(#mask0_239_68182)"
          }, /*#__PURE__*/_react["default"].createElement("circle", {
            cx: "13.4361",
            cy: "14.564",
            r: "8.94391",
            fill: "#0095E0"
          }), /*#__PURE__*/_react["default"].createElement("path", {
            d: "M9.70898 19.3552C9.70898 18.387 10.1016 17.4585 10.8005 16.7739C11.4994 16.0893 12.4472 15.7046 13.4356 15.7046C14.424 15.7046 15.3719 16.0893 16.0707 16.7739C16.7696 17.4585 17.1622 18.387 17.1622 19.3552H9.70898ZM13.4356 15.2483C11.8914 15.2483 10.6406 14.0231 10.6406 12.5104C10.6406 10.9977 11.8914 9.77246 13.4356 9.77246C14.9798 9.77246 16.2306 10.9977 16.2306 12.5104C16.2306 14.0231 14.9798 15.2483 13.4356 15.2483Z",
            fill: "white"
          })), /*#__PURE__*/_react["default"].createElement("rect", {
            x: "13.9563",
            y: "2.04517",
            width: "11.4782",
            height: "7.30429",
            rx: "2.60867",
            fill: "#3C3C3C",
            stroke: "white",
            strokeWidth: "1.04347"
          }), /*#__PURE__*/_react["default"].createElement("circle", {
            cx: "17.6082",
            cy: "5.69802",
            r: "1.04347",
            stroke: "white",
            strokeWidth: "1.04347"
          }), /*#__PURE__*/_react["default"].createElement("circle", {
            cx: "24.9131",
            cy: "3.08889",
            r: "1.5652",
            fill: "#DF434D",
            stroke: "white",
            strokeWidth: "1.04347"
          }));
        }
      }
    }
  }, [app, classes.camListImg, classes.camListImgAppLive, classes.camListImgLive, loc.active, loc.isPublic, loc.mode, loc.profile_img, loc.share_dev_name, loc.share_video, mobile]);
  var titleMarkup = (0, _react.useMemo)(function () {
    if (loc.share_dev_name === 'off') {
      return t('BLACKVUE');
    }
    return loc.name;
  }, [index, loc.name, loc.share_dev_name, t]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    key: loc.psn,
    style: {
      display: 'flex',
      alignItems: 'center',
      padding: '8px 0',
      borderBottom: !last ? "1px solid #EBEBEB" : undefined,
      cursor: 'pointer'
    },
    onClick: onClick
  }, logoMarkup, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      minWidth: 10,
      width: 10
    }
  }), /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Typography, {
    category: "Default",
    variant: "Body",
    style: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      color: colors.primary['1']
    }
  }, titleMarkup));
};
exports.CameraListItem = CameraListItem;